"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: ", ";\n  font-weight: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: ", ";\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 16px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-image: linear-gradient(\n    89deg,\n    ", " 0%,\n    ", " 100%\n  );\n  transition: width 0.6s ", ";\n  border-radius: ", ";\n  border-right: ", ";\n  color: ", ";\n  font-size: ", ";\n  height: 100%;\n  line-height: 16px;\n  text-align: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border-radius: ", ";\n  height: 16px;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ProgressWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIProgress__ProgressWrapper",
  componentId: "u97swd-0"
})(_templateObject(), function (_ref) {
  var use = _ref.use;
  return use === 'danger' ? _colors.CANDY_APPLE : _colors.KOALA;
}, _sizes.BUTTON_RADIUS);

var ProgressBar = _styledComponents.default.div.withConfig({
  displayName: "UIProgress__ProgressBar",
  componentId: "u97swd-1"
})(_templateObject2(), function (_ref2) {
  var use = _ref2.use;
  return use === 'success' ? _colors.OZ : _colors.SORBET;
}, function (_ref3) {
  var use = _ref3.use;
  return use === 'success' ? _colors.CALYPSO : _colors.MARIGOLD;
}, function (_ref4) {
  var easing = _ref4.easing;
  return easing;
}, function (_ref5) {
  var use = _ref5.use;
  return use !== 'danger' && _sizes.BUTTON_RADIUS;
}, function (_ref6) {
  var use = _ref6.use;
  return use === 'danger' && "3px " + _colors.OLAF + " solid";
}, _colors.OLAF, _sizes.MICROCOPY_SIZE);

var ProgressAndLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIProgress__ProgressAndLabelWrapper",
  componentId: "u97swd-2"
})(_templateObject3());

var StackedLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIProgress__StackedLabelWrapper",
  componentId: "u97swd-3"
})(_templateObject4(), _sizes.DISTANCE_MEASUREMENT_EXTRA_SMALL);

var DescriptiveLabel = _styledComponents.default.div.withConfig({
  displayName: "UIProgress__DescriptiveLabel",
  componentId: "u97swd-4"
})(_templateObject5(), _sizes.FORM_COPY_SIZE);

var ValueLabel = _styledComponents.default.div.withConfig({
  displayName: "UIProgress__ValueLabel",
  componentId: "u97swd-5"
})(_templateObject6(), _sizes.FORM_COPY_SIZE, _misc.WEB_FONT_DEMI_BOLD_WEIGHT);

var getStyle = function getStyle(style, rawPercentage) {
  return (0, _extends2.default)({}, style, {
    width: rawPercentage * 100 + "%"
  });
};

var UIProgress = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIProgress, _PureComponent);

  function UIProgress(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIProgress);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIProgress).call(this, props));
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    return _this;
  }

  (0, _createClass2.default)(UIProgress, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          descriptiveLabel = _this$props.descriptiveLabel,
          easing = _this$props.easing,
          hasLabel = _this$props.hasLabel,
          min = _this$props.min,
          max = _this$props.max,
          style = _this$props.style,
          use = _this$props.use,
          value = _this$props.value,
          valueLabel = _this$props.valueLabel,
          wrapperClassName = _this$props.wrapperClassName,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "descriptiveLabel", "easing", "hasLabel", "min", "max", "style", "use", "value", "valueLabel", "wrapperClassName"]);
      var rawPercentage = Math.min(value / max, 1);

      var formattedPercentage = _I18n.default.formatPercentage(rawPercentage * 100);

      var renderedLabel;

      if (children != null) {
        renderedLabel = children;
      } else if (hasLabel) {
        renderedLabel = _react.default.createElement("span", null, formattedPercentage);
      } else {
        renderedLabel = _react.default.createElement("span", {
          className: "sr-only"
        }, _I18n.default.text('ui.progress.percentComplete', {
          percent: formattedPercentage
        }));
      }

      var stackedLabel = valueLabel != null || descriptiveLabel != null ? _react.default.createElement(StackedLabelWrapper, null, _react.default.createElement(DescriptiveLabel, null, descriptiveLabel), _react.default.createElement(ValueLabel, null, valueLabel)) : null;
      return _react.default.createElement(ProgressAndLabelWrapper, {
        className: wrapperClassName
      }, stackedLabel, _react.default.createElement(ProgressWrapper, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-progress', className),
        use: use
      }), _react.default.createElement(ProgressBar, {
        "aria-valuemax": max,
        "aria-valuemin": min,
        "aria-valuenow": value,
        className: "private-progress__bar",
        easing: easing,
        role: "progressbar",
        style: this._getStyle(style, rawPercentage),
        use: use
      }, renderedLabel)));
    }
  }]);
  return UIProgress;
}(_react.PureComponent);

UIProgress.propTypes = {
  children: _propTypes.default.node,
  descriptiveLabel: _propTypes.default.node,
  easing: _propTypes.default.string.isRequired,
  hasLabel: _propTypes.default.bool.isRequired,
  max: _propTypes.default.number.isRequired,
  min: _propTypes.default.number.isRequired,
  use: _propTypes.default.oneOf(['success', 'danger', 'warning']).isRequired,
  value: _propTypes.default.number.isRequired,
  valueLabel: _propTypes.default.node,
  wrapperClassName: _propTypes.default.string
};
UIProgress.defaultProps = {
  easing: 'ease',
  hasLabel: false,
  min: 0,
  max: 100,
  use: 'success',
  value: 0
};
UIProgress.displayName = 'UIProgress';
var _default = UIProgress;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/progress/UIProgress.js
// module id = 851
// module chunks = 209 210 211 212